import {Component, OnInit} from '@angular/core';
import {Viewable} from '../../../../models/protocols/viewable';
import {DashboardViewModel} from './dashboard-view-model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, Viewable {

  constructor(
    public viewModel: DashboardViewModel,
  ) {
  }

  ngOnInit(): void {
  }

  setupViews() {
  }

  setupBindings() {
  }

}
